import "./style.less";

export default function bookingExpired() {
    return {
        restrict: "E",
        scope: {
            bookingError: "<",
        },
        template: require("./template.html"),

        controller: function ($scope, $timeout) {
            // $timeout(() => {
            //     // console.log($scope.bookingError);
            //     //$location.path("/");
            // }, 5000);
        },
    };
}
